import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "v-fade book-export__copy-notification" }


export default /*@__PURE__*/_defineComponent({
  __name: 'CopyMessagePopup',
  props: {
    show: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", null, "Copied", -1)
  ]))], 512)), [
    [_vShow, __props.show]
  ])
}
}

})